import { bodyLayoutWidth } from './BodyBgStore.js';

export const updateBodyLayoutWidth = (value) => bodyLayoutWidth.update((oldValue) => value);
